// extracted by mini-css-extract-plugin
export var navbarSubLink = "Z_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "Z_vY d_f0 d_dB";
export var subPageLink = "Z_gf d_gf";
export var burger = "Z_yb";
export var sublinkSize = "Z_yc";
export var linkSize = "Z_yd";
export var Link = "Z_tv G_tv G_sX G_tg";